import { AddressComponent } from "components/LocationAutocomplete/schema";

export interface FairPaySurveyResponse {
  id: number;
  surveyUuid: string;
  firstName?: string;
  instagramUsername?: string;
  tiktokUsername?: string;
  youtubeUsername?: string;
  email?: string | null;
  integrationEmail?: string | null;
  employmentTypePercentile?: number;
  employmentType?: FairPayEmploymentType;
  followerCountPercentile?: number;
  followerCount?: FairPaySurveyFollowerCount;
  niche?: string;
  nichePercentile?: number;
  locationPercentile?: number;
  addressComponents?: AddressComponent[];
  country?: string;
  city?: string;
  cityPercentile?: number;
  gender?: FairPayGender;
  creatorType?: FairPayCreatorType;
  currency?: FairPayCurrency;
  monthlyIncome?: FairPayMonthlyIncome;
  annualIncome?: FairPayAnnualIncome;
  experienceLength?: FairPayExperienceLength;

  highestEarningBrand?: string;
  highestEarningBrandIncome?: number;
  brandIncomePercentile?: number;
  partnershipsSearchCompletedAt?: number;
  partnershipsSearchedAt?: number;
}

export interface FairPaySurveyPartnership {
  id: number;
  brandName: string;
  brandWebsite: string;
  rangeComparison: string;
  yourRate: number;
  typicalRange: string;
}

export enum FairPaySurveyFollowerCount {
  less_than_ten_k = "<10K",
  ten_to_fifty_k = "10K-50K",
  fifty_to_one_hundred_fifty_k = "50K-150K",
  one_hundred_fifty_to_five_hundred_k = "150K-500K",
  five_hundred_to_one_m = "500K-1M",
  one_m_plus = "1M+",
}

export enum FairPayNiche {
  fashion = "fashion",
  beauty = "beauty",
  lifestyle = "lifestyle",
  health_wellness = "health/wellness",
  pets = "pets",
  tech_saas = "tech/saas",
  coaching_education = "coaching/education",
  home = "home",
  kids_family = "kids/family",
  travel = "travel",
  food_beverage = "food/beverage",
  local = "local",
  other = "other",
}

export enum FairPayGender {
  male = "male",
  female = "female",
  non_binary = "non-binary",
  prefer_not_to_say = "prefer-not-to-say",
  other = "other",
}

export enum FairPayCreatorType {
  influencer = "influencer",
  ugc_creator = "ugc-creator",
  coach = "coach",
  other = "other",
}

export enum FairPayCurrency {
  USD = "USD",
  CAD = "CAD",
  EUR = "EUR",
  GBP = "GBP",
  AUD = "AUD",
  NZD = "NZD",
  other = "other",
}

export enum FairPayEmploymentType {
  part_time = "part-time",
  full_time = "full-time",
}

export enum FairPayExperienceLength {
  less_than_one_year = "<1 year",
  one_to_two_years = "1-2 years",
  three_to_five_years = "3-5 years",
  more_than_five_years = ">5 years",
}

export enum FairPayMonthlyIncome {
  under_one_k = "<1K",
  one_to_three_k = "1-3K",
  three_to_six_k = "3-6K",
  six_to_ten_k = "6-10K",
  ten_to_fifteen_k = "10-15K",
  fifteen_to_twenty_k = "15-20K",
  twenty_k_plus = "20K+",
}

export enum FairPayAnnualIncome {
  zero = "0",
  under_ten_k = "<10K",
  ten_to_thirty_k = "10-30K",
  thirty_to_sixty_k = "30-60K",
  sixty_to_ninety_k = "60-90K",
  ninety_to_one_twenty_k = "90-120K",
  one_twenty_to_one_fifty_k = "120-150K",
  one_fifty_to_two_hundred_k = "150-200K",
  two_hundred_k_plus = "200K+",
}

export enum FairPayOnboardingPage {
  socials = "Your Socials",
  about_you = "About You",
  deals = "Deals & Earnings",
  connect = "Connect to Gmail",
}

export const FairPayOnboardingPagesOrder = [
  FairPayOnboardingPage.socials,
  FairPayOnboardingPage.about_you,
  FairPayOnboardingPage.deals,
  FairPayOnboardingPage.connect,
];

export const RequiredFieldsForFairPaySurveyResponse = {
  [FairPayOnboardingPage.socials]: ["firstName"],
  [FairPayOnboardingPage.about_you]: [
    "niche",
    "addressComponents",
    "employmentType",
  ],
  [FairPayOnboardingPage.deals]: [
    "monthlyIncome",
    "annualIncome",
    "experienceLength",
  ],
  // Special handling on the email page
  [FairPayOnboardingPage.connect]: [],
};

export const RequiredFieldLabel = {
  firstName: "Your First Name",
  niche: "Your Niche / Category",
  addressComponents: "Your Location",
  employmentType: "Full-time or Part-time Creator",
  monthlyIncome: "Monthly income",
  annualIncome: "Annual income",
  experienceLength: "How long you've been earning income",
};

export type ErrorField = {
  name: string;
  message: string;
};
